import React from "react";
import { IconType } from "./types";

const Reshop: IconType = (props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 -5 32 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M0.0128677 0.792095C0.0128677 0.354188 0.36673 0 0.804231 0H17.4196C21.28 0 25.0728 1.59063 27.8199 4.36297C30.5287 7.09665 32.0085 10.6707 31.9794 14.4316C31.9794 14.6151 31.9794 14.7954 31.9666 14.979C31.8443 17.7417 30.8793 20.3883 29.2354 22.6166C28.1417 24.0977 26.739 25.3245 25.1724 26.2936L22.0842 28.2064C21.8719 28.3383 21.9651 28.6635 22.2128 28.6635H30.1459C30.5834 28.6635 30.9373 29.0178 30.9373 29.4556V33.8026C30.9373 34.2403 30.5834 34.5946 30.1459 34.5946H16.8342C14.4762 34.5946 12.5653 32.682 12.5653 30.3218V17.6547C12.5653 17.2168 12.9192 16.8626 13.3567 16.8626H17.7188C18.1563 16.8626 18.5102 17.2168 18.5102 17.6547V24.0559C18.5102 24.278 18.7773 24.3875 18.9315 24.2297L22.9431 20.2017C24.513 18.6304 25.3784 16.5438 25.3784 14.3253C25.3784 9.74341 21.6531 6.01799 17.0722 6.01799H7.46005C7.02255 6.01799 6.6687 6.37219 6.6687 6.81008V33.8026C6.6687 34.2403 6.31483 34.5946 5.87733 34.5946H0.791363C0.353861 34.5946 0 34.2403 0 33.8026L0.0128677 0.792095Z"
      fill="#FF5734"
    />
  </svg>
);

export default Reshop;
